export default {"src":"/_next/static/media/heart-filled-red-46x46.ebb87378.svg","height":18,"width":21};